import { createContext, useState, useEffect, useContext } from "react";



const CartContext = createContext();

export function CartProvider({ children }) {
  const [cart, setCart] = useState([]);

  const fetchCart = async ({ setLoading, showToast }) => {
    try {
      setLoading?.(true);
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/cart`, {
        method: "GET",
        credentials: "include",
      });
  
      const data = await res.json();
  
      if (!res.ok) throw new Error(data.error || "Failed to fetch cart data");
      setCart?.(data.items || []);
    } catch (error) {
      console.error("Error fetching cart:", error);
    } finally {
      setLoading?.(false);
    }
  };
  
  useEffect(() => {
    fetchCart({});
  }, []);

  const addToCart = async (medicineId, quantity, prescriptionDetail = null, { setLoading, showToast }) => {
    try {
      setLoading?.(true);
  
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/cart`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ medicineId, quantity, prescriptionDetail }),
      });
  
      const data = await res.json();
  
      if (!res.ok) {
        throw new Error(data.error || "Failed to add item to cart");
      }
  
      await fetchCart({ setLoading, showToast });
  
      showToast?.("Item added to cart!", { type: "success" });
    } catch (error) {
      console.error(error);
      showToast?.("Could not add to cart", { type: "error" });
    } finally {
      setLoading?.(false);
    }
  };
  

  const removeFromCart = async (medicineId, { setLoading, showToast }) => {
    try {
      setLoading?.(true);
  
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/cart/${medicineId}`, {
        method: "DELETE",
        credentials: "include",
      });
  
      const data = await res.json();
  
      if (!res.ok) {
        throw new Error(data.error || "Failed to remove item from cart");
      }
      await fetchCart({ setLoading, showToast });
      showToast?.("Item removed from cart!", { type: "success" });
    } catch (error) {
      console.error("Error removing from cart:", error);
      showToast?.("Failed to remove item from cart", { type: "error" });
    } finally {
      setLoading?.(false);
    }
  };
  
  const clearCart = async ({ setLoading, showToast}) => {
    try {
      setLoading?.(true);
  
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/cart`, {
        method: "DELETE",
        credentials: "include",
      });
  
      const data = await res.json();
  
      if (!res.ok) {
        throw new Error(data.error || "Failed to clear cart");
      }
      await fetchCart({ setLoading, showToast });

      showToast?.("Cart cleared successfully!", { type: "success" });
    } catch (error) {
      console.error("Error clearing cart:", error);
      showToast?.("Failed to clear cart", { type: "error" });
    } finally {
      setLoading?.(false);
    }
  };
  

  return (
    <CartContext.Provider value={{ cart,setCart, fetchCart, addToCart, removeFromCart, clearCart }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
